import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  page: {
    width: '100%',
    flexDirection: 'column',
    fontFamily: 'Roboto',
    fontWeight: 'normal',
    fontSize: 11,
    marginTop: 35,
    marginBottom: 25,
  },
  page2: {
    width: '100%',
    flexDirection: 'column',
    fontFamily: 'Roboto',
    fontWeight: 'normal',
    fontSize: 9,
    marginTop: 11,
    marginBottom: 11,
  },
  imageSection: {
    margin: '0% 15% 10% 15%',
    width: '70%',
    alignItems: 'center',
  },
  section: {
    margin: '3px 20px 3px 20px',
    lineHeight: 1.2,
    padding: '3px 20px 3px 20px',
  },
  sectionBetween: {
    lineHeight: 1.2,
    padding: '3px 20px 3px 20px',
  },
  finalsection: {
    padding: '40px 40px 40px 40px',
    margin: '40px 40px 40px 40px',
    fontWeight: 'bold',
  },
  arabicColumn: {
    width: '40%',
    lineHeight: 0,
    alignItems: 'center',
    flexDirection: 'column',
  },
  arabicElements: {
    width: '40%',
    lineHeight: 0,
    alignItems: 'center',
    padding: 5,
  },
  rowColumn: {
    justifyContent: 'space-between',
    flexGrow: 1,
    width: '100%',
    flexDirection: 'row-reverse',
  },
  arabicItem: {
    width: '20%',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  tableElem: {
    flexDirection: 'row-reverse',
  },
  checkboxContainer: {
    flexDirection: 'row-reverse',
    alignItems: 'center',
  },

  frenchColumn: {
    width: '60%',
    alignItems: 'center',
    flexDirection: 'column',
  },
  row: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'row',
  },
  column: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
  },
  text: {
    fontFamily: 'NotoSansArabic',
  },
  arabicText: {
    fontFamily: 'NotoArabic',
  },
  cnraArabicText: {
    fontFamily: 'NotooArabic',
  },
  headerBg: {
    backgroundColor: 'white',
  },

  tableRow: {
    flexDirection: 'row',
  },
  tableWidth: {
    width: '50%',
    padding: 5,
  },
  textCenter: {
    textAlign: 'center',
  },
  withUnderline: {
    textDecoration: 'underline',
    fontWeight: 'bold',
  },
  withBorder: {
    border: '1.5px solid black',
    margin: 2,
    fontFamily: 'Roboto',
    alignSelf: 'center',
    alignContent: 'center',
    textAlign: 'center',
    width: '100%',
    lineHeight: 1,
  },
  textBorder: {
    border: '1.5px solid black',
    padding: '3px 7px',
    fontFamily: 'Roboto',
    alignSelf: 'center',
    alignContent: 'center',
    textAlign: 'center',
    lineHeight: 1,
    justifyContent: 'flex-start',
  },
  withBottomBorder: {
    borderBottom: '1px solid black',
    lineHeight: 1,
    width: '100%',
  },
  withTopBorder: {
    borderTop: '1px solid black',
    lineHeight: 1.2,
    width: '100%',
    margin: '0px 3px 0px 3px',
    paddingTop: 3,
    textAlign: 'right',
    fontStyle: 'italic',
    fontWeight: 'bold',
  },
  boldText: {
    fontWeight: 'bold',
  },
  borderColumn: {
    alignItems: 'flex-start',
  },
  italicText: {
    fontWeight: 300,
    fontStyle: 'italic',
  },
  bloc: {
    padding: '10px 10px 0px 10px',
    marginLeft: 10,
    marginRight: 10,
  },
  item: {
    padding: '0px 5px 0px 5px',
  },
  headerText: {
    fontWeight: 'bold',
    fontSize: 12,
    textAlign: 'center',
  },
  textBox: {
    border: '1.5px solid black',
    padding: '3px 7px',
    fontFamily: 'Roboto',
    fontSize: 9,
    alignSelf: 'center',
    alignContent: 'center',
    textAlign: 'left',
    lineHeight: 1,
    fontWeight: 'bold',
    justifyContent: 'flex-start',
    marginBottom: 5,
    width: 230,
    marginRight: 10,
  },
  textBoxSecond: {
    border: '1.5px solid black',
    padding: '3px 7px',
    fontFamily: 'Roboto',
    alignSelf: 'center',
    alignContent: 'center',
    textAlign: 'left',
    lineHeight: 1,
    fontSize: 9,

    justifyContent: 'flex-start',
    marginBottom: 5,
    width: 150,
    fontWeight: 'bold',
    marginRight: 10,
  },
  textBoxForth: {
    border: '1.5px solid black',
    padding: '3px 7px',
    fontFamily: 'Roboto',
    alignSelf: 'center',
    fontSize: 9,

    alignContent: 'center',
    textAlign: 'center',
    lineHeight: 1,
    justifyContent: 'flex-start',
    marginBottom: 5,
    width: 390,
    fontWeight: 'bold',
    marginRight: 10,
  },
  textBoxThird: {
    border: '1.5px solid black',
    padding: '3px 7px',
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    alignSelf: 'center',
    fontSize: 9,
    alignContent: 'center',
    textAlign: 'left',
    lineHeight: 1,
    justifyContent: 'flex-start',
    marginBottom: 5,
    width: 190,
    marginRight: 10,
  },
  textBoxSmall: {
    border: '1.5px solid black',
    padding: '3px 7px',
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    alignSelf: 'center',
    alignContent: 'center',
    textAlign: 'left',
    fontSize: 9,
    lineHeight: 1,
    justifyContent: 'flex-start',
    marginBottom: 5,
    width: 110,
    marginRight: 10,
    height: 18,
  },
  textBoxFifth: {
    border: '1.5px solid black',
    padding: '3px 7px',
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    alignSelf: 'center',
    alignContent: 'center',
    textAlign: 'center',
    lineHeight: 1,
    fontSize: 9,
    justifyContent: 'flex-start',
    marginBottom: 5,
    width: 150,
    marginRight: 10,
  },
  bullet: {
    width: 10,
    fontWeight: 'bold',
  },
  dotText: {
    fontSize: 9,
  },
  finalsection2: {
    fontWeight: 'bold',
  },
  uppercase: { textTransform: 'uppercase' },
  finalsectionSignature: {
    fontWeight: 'bold',
    padding: '3px 20px 3px 20px',
    justifyContent: 'space-between',
    flexGrow: 1,
    width: '100%',
    flexDirection: 'row-reverse',
  },
});
